import { InitSliceListenersParams } from 'store/queries/types';
import { getAxiosAccountingErrorMessage } from 'store/utils/getAxiosAccountingErrorMessage';
import { signOut } from 'modules/auth/actions/signOut';

import { callEndpoint } from '../utils/callEndpoint';
import { isTFAEndpointMeta } from '../utils/isTFAEndpointMeta';
import { isTFAError } from '../utils/isTFAError';
import { isTFARejectedAction } from '../utils/isTFARejectedAction';
import {
  setIsTFADialogOpened,
  setIsTFAEndpointRefetching,
  setTFAError,
  setTOTP,
} from './tfaSlice';

export const initTFAListeners = ({
  listenerMiddleware,
}: InitSliceListenersParams) => {
  listenerMiddleware.startListening({
    matcher: isTFARejectedAction,
    effect: async (
      {
        meta: {
          arg: { endpointName, originalArgs: params },
          baseQueryMeta,
        },
      },
      { condition, dispatch, fork, take },
    ) => {
      const shouldOpenTFADialog =
        !baseQueryMeta ||
        (isTFAEndpointMeta(baseQueryMeta) &&
          !baseQueryMeta.preventTFADialogOpening);

      if (shouldOpenTFADialog) {
        dispatch(setIsTFADialogOpened(true));

        const signOutOnTFADialogCloseTask = fork(async () => {
          // waiting for close action
          await condition(
            action =>
              setIsTFADialogOpened.match(action) && action.payload === false,
          );

          const shouldSignOut =
            isTFAEndpointMeta(baseQueryMeta) &&
            baseQueryMeta.shouldSignOutOnTFAError;

          if (shouldSignOut) {
            dispatch(signOut.initiate());
          }
        });

        const [{ payload: totp }] = await take(setTOTP.match);

        if (totp) {
          dispatch(setIsTFAEndpointRefetching(true));

          const { error } = await dispatch(
            callEndpoint({ endpointName, params, totp }),
          );

          dispatch(setIsTFAEndpointRefetching(false));

          if (isTFAError(error)) {
            const message = getAxiosAccountingErrorMessage(error);

            dispatch(setTFAError(message));

            dispatch(setIsTFADialogOpened(true));
          } else {
            signOutOnTFADialogCloseTask.cancel();

            dispatch(setIsTFADialogOpened(false));
          }
        }
      }
    },
  });
};
